import { render, staticRenderFns } from "./CostCenter.vue?vue&type=template&id=66e51436&scoped=true&lang=pug&"
import script from "./CostCenter.vue?vue&type=script&lang=ts&"
export * from "./CostCenter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e51436",
  null
  
)

export default component.exports